import { Icon, IconProps } from "..";

export const BaseballBat = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4444 3.5V4.38889H15.5556V5.27778H14.6667V6.16667H13.7778V7.05556H12.8889V7.94444H12V8.83333H11.1111V9.72222H10.2222V11.5H9.33333V12.3889H8.44444V14.1667H7.55556V15.0556H6.66667V15.9444H5.77778V16.8333H4V18.6111H4.88889V19.5H6.66667V17.7222H7.55556V16.8333H8.44444V15.9444H9.33333V15.0556H11.1111V14.1667H12V13.2778H13.7778V12.3889H14.6667V11.5H15.5556V10.6111H16.4444V9.72222H17.3333V8.83333H18.2222V7.94444H19.1111V7.05556H20V4.38889H19.1111V3.5H16.4444ZM8.44444 15.0556H7.55556V15.9444H6.66667V16.8333H5.77778V17.7222H4.88889V18.6111H5.77778V17.7222H6.66667V16.8333H7.55556V15.9444H8.44444V15.0556ZM8.44444 15.0556H9.33333V14.1667H8.44444V15.0556ZM15.5556 7.94444V7.05556H16.4444V6.16667H17.3333V5.27778H16.4444V6.16667H15.5556V7.05556H14.6667V7.94444H15.5556Z"
        fill="currentColor"
      />
    </Icon>
  );
};
